import React, { Component } from 'react'
import { Navbar } from 'react-bootstrap'

import HeaderLinks from './HeaderLinks.jsx'

import partnerRoutes from 'routes/partner.jsx'

class Header extends Component {
    constructor(props) {
        super(props)
        this.mobileSidebarToggle = this.mobileSidebarToggle.bind(this)
    }

    componentDidMount() {
        document.body.classList.toggle('sidebar-mini')
    }

    makeBrand() {
        var name
        partnerRoutes.map((prop, key) => {
            const { pathname } = this.props.location
            if (prop.redirect) {
                if (prop.path === pathname) { name = prop.name }
            } else {
                if (prop.path === pathname) { name = prop.name }
            }
            return null
        })
        return name
    }

    mobileSidebarToggle(e) {
        document.documentElement.classList.toggle('nav-open')
    }
    render() {
        return (
            <Navbar fluid>
                <Navbar.Header>
                    <Navbar.Brand>
                        <a>{this.makeBrand()}</a>
                    </Navbar.Brand>
                    <Navbar.Toggle onClick={this.mobileSidebarToggle} />
                </Navbar.Header>
                {window.innerWidth > 992 ? (<Navbar.Collapse><HeaderLinks /></Navbar.Collapse>) : null}
            </Navbar>
        )
    }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/PartnerHeader.jsx